import {useMemo} from 'react';
import {usePressReleaseQuery} from '../../api/queries/use-press-release-query';
import {composeImageUrl} from '../../lib/compose-image-url';

export const useMainImage = () => {
  const {data: pressRelease} = usePressReleaseQuery();

  const url = useMemo(() => {
    if (pressRelease === undefined || pressRelease.imageFileNameMain === null) {
      return null;
    }

    const composedUrl = composeImageUrl(
      pressRelease.companyId,
      pressRelease.releaseId,
      {
        fileNameS3: pressRelease.imageFileNameMainS3,
        fileName: pressRelease.imageFileNameMain,
      },
    );

    return composedUrl;
  }, [pressRelease]);

  const caption = useMemo(() => {
    if (pressRelease === undefined || pressRelease.imageFileNameMain === null) {
      return null;
    }

    // fileName の一致する image を images から検索
    const image = pressRelease.images.find(
      (index) => index.fileName === pressRelease.imageFileNameMain,
    );
    // キャプションが指定されていない時、null を返す
    const result = image?.caption ?? null;

    return result;
  }, [pressRelease]);

  if (url === null) {
    return null;
  }

  return {
    url,
    caption,
  };
};
